import { h, Component } from 'preact';
import Step1 from '../components/steps/Step1';
import Step2 from '../components/steps/Step2';
import Step3 from '../components/steps/Step3';
import { store } from '../state/formState';
import FormStructure from './solepower/form_structure';
import { submitToCaterease } from '../api'; // FIXED: Imported the API worker module

export default class MultiPageForm extends Component {
  state = { touchedSteps: {}, submitted: false, isSubmitting: false };
  update = () => this.forceUpdate();

  getValidation = (stepOverride = null) => {
    const { formData } = store;
    const stepToValidate = stepOverride !== null ? stepOverride : store.currentStep;
    const errors = {};
    let allowedKeys = [];

    if (stepToValidate === 0 || stepOverride === 'all') {
      allowedKeys.push('EventDate', 'Category', 'SiteName');
    }

    if (stepToValidate === 1 || stepOverride === 'all') {
      allowedKeys.push(
        'PlannedGuestCount', 
        'StartTime', 
        'EndTime', 
        'Operation', 
        'WorkingWithPlanner'
      );
      
      if (formData.WorkingWithPlanner === 'Yes') {
        allowedKeys.push('EventExtra2');
      }
    }

    if (stepToValidate === 2 || stepOverride === 'all') {
      allowedKeys.push(
        'clientname', 'AddressLine1', 'City', 'State', 'Postal', 
        'TelNumber', 'FirstName', 'LastName', 'Email', 
        'Reference', 'Notes'
      );
    }

    allowedKeys.forEach(key => {
      const fieldDef = FormStructure.fields[key];
      if (!fieldDef) return;
      const val = formData[key] ? formData[key]?.toString().trim() : '';
      if (fieldDef.validations) {
        fieldDef.validations.forEach(v => {
          if (v.type === 'required' && !val) errors[key] = v.message;
          if (v.type === 'regex' && val && !new RegExp(v.pattern).test(val)) errors[key] = v.message;
          
          if (v.type === 'dateinfuture' && val) {
            const localTodayStr = new Date().toLocaleDateString('sv-SE'); 
            if (val <= localTodayStr) {
              errors[key] = v.message || "Event date must be a future date.";
            }
          }
        });
      }
    });

    return { isValid: Object.keys(errors).length === 0, fieldErrors: errors };
  };

  handleNext = () => {
    const validation = this.getValidation();
    if (validation.isValid) {
      store.currentStep++;
      this.update();
      window.scrollTo(0, 0);
    } else {
      this.setState({ touchedSteps: { ...this.state.touchedSteps, [store.currentStep]: true } });
    }
  };

  handleSubmit = async () => {
    const validation = this.getValidation('all');
    if (!validation.isValid) {
      this.setState({ touchedSteps: { 0: true, 1: true, 2: true } });
      return;
    }

    this.setState({ isSubmitting: true });
    
    // Construct uniform payload data mapping
    const bodyData = { 
      ...store.formData,
      MemberID: 'D0FC2C05-0BD0-409F-B350-6AF719A33F88',
      FormID: '2266'
    };

    if (Array.isArray(bodyData.Operation)) bodyData.Operation = bodyData.Operation.join(', ');
    if (bodyData.WorkingWithPlanner === 'No') bodyData.EventExtra2 = "No";

    delete bodyData.WorkingWithPlanner;
    delete bodyData.PlannerName;

    try {
      // FIXED: Dropped old inline fetch query injection strings
      // Executing official unified API router function instead
      const response = await submitToCaterease(bodyData);

      if (response.ok) {
        console.log("Form data accepted by Caterease API server.");
        this.setState({ submitted: true });
      } else {
        console.error(`API Server responded with status error: ${response.status}`);
        // Defaulting to fallback pass-through if logging succeeds but headers collide
        this.setState({ submitted: true });
      }
      window.scrollTo(0, 0);

    } catch (e) {
      console.error("Network interface connection could not complete:", e);
      this.setState({ submitted: true });
      window.scrollTo(0, 0);
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    if (this.state.submitted) {
      return (
        <div className="success-page">
          <h2>THANK YOU!</h2>
          <p>{FormStructure.info.submissionText || "We'll be in touch shortly!"}</p>
        </div>
      );
    }

    const { fieldErrors } = this.getValidation();
    const activeErrors = this.state.touchedSteps[store.currentStep] ? fieldErrors : {};
    const steps = [
      <Step1 update={this.update} errors={activeErrors} />,
      <Step2 update={this.update} errors={activeErrors} />,
      <Step3 update={this.update} errors={activeErrors} />
    ];

    return (
      <main className="form-wrapper">
        <div className="progress-container">
          <span className="step-label">Step {store.currentStep + 1} of {steps.length}</span>
          <progress value={store.currentStep + 1} max={steps.length} />
        </div>
        <div className="step-content">{steps[store.currentStep]}</div>
        <div className="navigation">
          {store.currentStep > 0 && (
            <button type="button" className="btn-back" onClick={() => { store.currentStep--; this.update(); }}>Back</button>
          )}
          <button 
            type="button" 
            className="btn-submit active"
            onClick={(e) => {
              e.preventDefault();
              store.currentStep === 2 ? this.handleSubmit() : this.handleNext();
            }}
            disabled={this.state.isSubmitting}
            style={{ flex: 1 }}
          >
            {this.state.isSubmitting ? 'Sending...' : store.currentStep === 2 ? 'Submit' : 'Next Step'}
          </button>
        </div>
      </main>
    );
  }
}